export enum VelocityType {
  Linear = 'linear',
  Angular = 'angular'
}
